import questionReducer from './';

export default questionReducer;
